export const DepositPaymentDirectionEnum = {
  Incoming: 'Incoming',
  Outgoing: 'Outgoing',
} as const;
export type DepositPaymentDirectionEnum = (typeof DepositPaymentDirectionEnum)[keyof typeof DepositPaymentDirectionEnum];
